import React from "react";
import { Link as RouterLink, useParams } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Typography } from "@material-ui/core";
import Footer from "../components/Footer";

const useStyles = makeStyles((theme) => ({
  landingWrapper: {
    height: "auto",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  landingContainer: {
    paddingTop: 16,
    paddingBottom: 16,
    minHeight: "calc(100vh - 60px)",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  landingTitle: {
    margin: "32px 0",
    fontWeight: 600,
  },
  landingTitleMedium: {
    margin: "32px 0",
    fontWeight: 500,
  },
  landingTitleDruid: {
    fontWeight: 600,
    color: theme.custom.colors.fontDark,
  },
  landingSubtitle: {
    lineHeight: "1.625em",
  },
  backToHomeButton: {
    margin: "32px 0",
  },
}));

const Landing = () => {
  const classes = useStyles();
  const { code } = useParams();

  let extractedCodeDruid = "";
  if (typeof code === "string" && code.includes("error-druid-")) {
    extractedCodeDruid = code.split("error-druid-")[1]; // Extract code after "error-druid-"
  }

  return (
    <>
      <div className={classes.landingWrapper}>
        <Container maxWidth="md" className={classes.landingContainer}>
          {!isNaN(Number(code)) ? (
            <Typography variant="h2" className={classes.landingTitle}>
              {code}
            </Typography>
          ) : (
            <Typography variant="h6" className={classes.landingTitleMedium}>
              It seems the media information for the ID{" "}
              <span className={classes.landingTitleDruid}>
                {extractedCodeDruid}{" "}
              </span>
              could not be found
            </Typography>
          )}

          <Typography variant="subtitle1" className={classes.landingSubtitle}>
            {parseInt(code) === 404 && (
              <>
                The page you were looking for doesn't exist.
                <br />
                You may have mistyped the address or the page may have moved.
              </>
            )}
            {parseInt(code) === 500 && (
              <>
                Internal server error.
                <br />
                Try to refresh this page or feel free to contact us if the
                problem persists.
              </>
            )}
            {typeof code === "string" && code.includes("error-druid-") && (
              <>
                This might be because the server is currently busy.
                <br />
                Please try refreshing the page.
                <br />
                <br />
                If the issue persists, feel free to contact our
                administrator—we’re here to help!
              </>
            )}
          </Typography>

          <div>
            <Button
              variant="contained"
              color="primary"
              size="large"
              className={classes.backToHomeButton}
              component={RouterLink}
              to="/"
            >
              Back to Home
            </Button>
          </div>
        </Container>

        <Footer />
      </div>
    </>
  );
};

export default Landing;
